<script>
    import { onMount } from 'svelte';

    let hls;
    let trc = 1;
    let playButt;
    let videoElem;

    export let pathname;

    const initHls = () => {
        hls = new Hls();
        //
        hls.attachMedia(videoElem);
        hls.on(Hls.Events.MEDIA_ATTACHED, function () {
            hls.loadSource(`https://sd.orgxxx.tv/ims1/mp4/${ pathname === '/' ? 'TESTFILM' : 'DEMO' }.m4v/playlist.m3u8`);
                hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                });
        });
    };

    const goPlay = () => {
        videoElem.play();
    };

    onMount(() => {
        videoElem.oncanplay = (event) => {
            videoElem.style.visibility = 'visible';
            playButt.style.visibility = 'visible';
        };
        videoElem.onplay = (event) => {
            playButt.style.display = 'none';
        };
    });

</script>


<div>
    <div class="flex">
        <div class="flex-grow"></div>
        <div class="relative flex-grow-0">
            <img bind:this={playButt} on:click={goPlay} class="invisible cursor-pointer absolute w-20 h-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hover:scale-110" src="/playbutt.png" alt="the play button"/>
            <!-- svelte-ignore a11y-media-has-caption -->
            <video bind:this={videoElem} class="object-center invisible" controls autoplay>
            </video>
        </div>
        <div class="flex-grow"></div>
    </div>
</div>

<svelte:head>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.0.0/hls.min.js" on:load={initHls}></script>
</svelte:head>
